
import {
	getSession,
} from 'Vulture/Session.js';

import {
	broncoURL,
} from './ENV';

export const vclDeleteValidation = async (vclID, accountUUID) => {
	const url = `${broncoURL}/visual_content_loop/${vclID}/validate_delete/${accountUUID}`;
	const sessionKey = getSession().session;

	return await fetch(url, {
		method:  'GET',
		headers: {
			'Content-Type':   'application/json',
			'X-Auth-Session': sessionKey,
		},
	})
		.then((data) => {
			return data.json();
		});
};